import styled from 'styled-components';

export const BoldText = styled.span`
  color: ${props =>
    props.theme.colors.get(props.color, props.theme.colors.text.secondary)};
  ${props => props.theme.typography.bodyBold}
`;
